import React from 'react';
import { Paper, PaperProps } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { units } from '../theme/units';

type Kind = 'mint' | 'muted' | 'mint-left-no-radius';

const useStyles = makeStyles()(theme => ({
  base: {
    display: 'inline-block',
    fontSize: units.rem(0.85),
    padding: units.trbl(0.25, 0.5, 0.25, 0.5),
  },
  'kind-mint': {
    color: '#fff',
    backgroundColor: theme.palette.secondary.main,
  },
  'kind-mint-left-no-radius': {
    color: '#fff',
    backgroundColor: theme.palette.secondary.main,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  'kind-muted': {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.secondary.main,
  },
}));

interface Props extends PaperProps {
  kind?: Kind;
}

const Badge: React.FC<Props> = ({ kind, children, ...rest }) => {
  const { classes, cx } = useStyles();

  return (
    <Paper
      elevation={0}
      className={cx(classes.base, {
        [classes[`kind-${kind}`]]: Boolean(kind),
      })}
      {...rest}
    >
      {children}
    </Paper>
  );
};

export { Badge };
